import { render, staticRenderFns } from "./tnc-in.vue?vue&type=template&id=ff67de0c&scoped=true"
import script from "./tnc-in.vue?vue&type=script&lang=js"
export * from "./tnc-in.vue?vue&type=script&lang=js"
import style0 from "./tnc-in.vue?vue&type=style&index=0&id=ff67de0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff67de0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff67de0c')) {
      api.createRecord('ff67de0c', component.options)
    } else {
      api.reload('ff67de0c', component.options)
    }
    module.hot.accept("./tnc-in.vue?vue&type=template&id=ff67de0c&scoped=true", function () {
      api.rerender('ff67de0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-in.vue"
export default component.exports